import Instruction from "./Instruction";

/**
 * Will reset all state to start a fresh conversation using a custom functionName as a start point.
 */
class Restart extends Instruction
{
	constructor(functionName)
	{
		super();
		this.functionName = functionName;
	}
}

export default Restart
